export const TabVectorRight = ({ className }) => (
  <svg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
    <path fillRule='evenodd' clipRule='evenodd' d='M10 10C10 10 1.21858e-06 10 1.58946e-07 0V6.12245V10H10Z' />
  </svg>
)
